/*!
 * Init linked product option selectors for multiple products
 */ import { h, render } from 'preact';
import { create } from 'superstruct';
import { kebabCase } from '../string/kebab-case';
import { App } from './app';
import { ProductOptionsIO } from './io';
const RENDER_TARGET_SELECTOR = '.js-product-options-render-target';
export const load = function(container, selectCallback) {
    var _product_variants_;
    const ioContainer = container.querySelector('script[type="application/json"]');
    const { product , optionsWithValues , selectedVariantId , settings , productTags , sale , hasProductEmbroidering , embroideringPrice , embroideryDisclaimer , customerId  } = create(JSON.parse(ioContainer ? ioContainer.textContent || '' : ''), ProductOptionsIO);
    const renderTarget = container.querySelector(RENDER_TARGET_SELECTOR);
    if (!renderTarget) {
        throw new Error('Render target element not found');
    }
    if (product.variants.length === 1 && kebabCase(((_product_variants_ = product.variants[0]) === null || _product_variants_ === void 0 ? void 0 : _product_variants_.title) || 'unknown').indexOf('default') >= 0) {
        return;
    }
    render(h(App, {
        product,
        optionsWithValues,
        selectedVariantId,
        settings,
        selectCallback,
        productTags,
        sale,
        hasProductEmbroidering,
        embroideringPrice,
        embroideryDisclaimer,
        customerId
    }), container, renderTarget);
};
export const unload = function(container) {
    const renderTarget = container.querySelector(RENDER_TARGET_SELECTOR);
    if (!renderTarget) {
        console.warn('Render target element not found');
        return;
    }
    render(null, container, renderTarget);
};
